import {JSONAttrs} from '../types';
import {ImageContainer} from '../styled';

type Props = {
  src: string;
  attrs: JSONAttrs;
};

function ImageItem({src, attrs}: Props) {
  return (
    <ImageContainer $align={attrs?.align}>
      <img src={src} width={attrs?.width} alt={src} />
    </ImageContainer>
  );
}

export {ImageItem};
